export default __webpack_public_path__ + "145baf1335a20828978a615a051599ef.svg";